import {
  BookOpenCheckIcon,
  ExternalLinkIcon,
  MailIcon,
  SendHorizonalIcon,
  SendIcon,
  UsersIcon,
  PlaySquareIcon,
} from "lucide-react";
import * as React from "react";
import { Button } from "../ui/button";
import { show, showNewMessage } from "@intercom/messenger-js-sdk";
import { useCanvasId } from "@/utils/utils";

interface Props {}

const InfoPanel: React.FunctionComponent<Props> = React.memo((props) => {
  const canvasId = useCanvasId();

  const getHelpInfo = () => {
    // Check if we're on a project page
    const urlParams = new URLSearchParams(window.location.search);
    const projectId = urlParams.get("project_id");

    // Default to canvas link if available
    if (canvasId) {
      return `Help Info: My canvas link is ${window.location.origin}/canvases/${canvasId}/editor\n\nMessage: `;
    }

    if (projectId) {
      return `Help Info: My project page link is ${window.location.origin}/?project_id=${projectId}\n\nMessage: `;
    }

    // If neither, just return the current URL
    return `Help Info: My page link is ${window.location.href}\n\nMessage: `;
  };

  const links = [
    {
      icon: BookOpenCheckIcon,
      title: "Docs",
      href: "https://tempolabsinc.mintlify.app",
    },
    {
      icon: PlaySquareIcon,
      title: "Tutorial",
      href: "https://www.youtube.com/watch?v=CaiKr-TONLY",
    },
    {
      icon: UsersIcon,
      title: "Community",
      href: "https://discord.gg/Arp8FZuBrs",
    },
    {
      icon: SendHorizonalIcon,
      title: "Contact Us",
      onClick: () => {
        showNewMessage(getHelpInfo());
      },
    },
  ];

  return (
    <div className="flex flex-col w-full">
      <div className="text-xs text-text-primary font-medium w-full border-b p-2">
        Resources
      </div>
      <div className="flex flex-col w-full p-2">
        {links.map((link) => (
          <Button
            key={link.title}
            variant="secondary"
            className="flex flex-row w-full gap-2 p-2 py-1 mb-1 justify-between cursor-pointer"
            onClick={() => {
              if (link.onClick) {
                link.onClick();
              } else {
                window.open(link.href, "_blank");
              }
            }}
          >
            <div className="flex flex-row gap-2 items-center">
              <link.icon className="size-3.5" />
              <span className="text-xs">{link.title}</span>
            </div>
            <ExternalLinkIcon
              className={link.onClick ? "hidden" : "size-3.5"}
            />
          </Button>
        ))}
      </div>
    </div>
  );
});

export default InfoPanel;
